import React, { useState, useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import GlobalApi from "../../../Global";
import refresh_token from "../../../Global/refresh_token";
import "../analytic.css";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Progress from "react-circle-progress-bar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Fab from "@material-ui/core/Fab";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Select from "@material-ui/core/Select";
import Link from "@material-ui/core/Link";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import TableRow from "@material-ui/core/TableRow";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InspectionAction from "../Actions/inspectionAction";
import { saveAs } from "file-saver";
import useDimensions from "../../../Global/useDimensions";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import DarkButton from "../../../Global/DarkButton";
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import Dialog from '@material-ui/core/Dialog';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import moment from "moment";
import swal from "@sweetalert/with-react";
import _, { filter } from "lodash";
import Chart from "react-google-charts";
import Colors from "../../../Global/colors";
import Spinner from "../../../Global/Spinner";
import { NewDashboard } from "./NewDashboard";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";




export default function Performances() {
  const {t} = useTranslation();
  let company = useSelector((state) => state.companyReducer.company);
  const history = useHistory();
  const { width } = useDimensions();

  const [value, setValues] = React.useState({
    from: moment()
      .subtract(9, "days")
      .toDate(),
    end: new Date(),
    previous_end:moment()
    .subtract(9, "days")
    .toDate(),
  previous_from: moment()
  .subtract(18, "days")
  .toDate(),
    custom_selected: "",
  });

  const [btnLoader, setBtnLoader] = React.useState(false)
  const [openModalPerformance,setModalPerformance]=React.useState(false)
  
  const setModal=(tab,state)=>{
    setModalPerformance(state)
  }
  const [performanceData, setPerformanceData] = React.useState({
    chart_data: [],
    inspection: [],
    grouped_sections: {},
  });

  const [performanceDataPrevious, setPerformanceDataPrevious] = React.useState({
    inspection: [],
    grouped_sections: {},
  });

  const [filteredInspection, setFilteredInspection] = React.useState([]);
  let companies = useSelector((state) => state.companyArrReducer.company);
  const [templates, setTemplates] = React.useState([]);
  const [inspections, setInspections] = React.useState([]);
  const [sites, setSites] = React.useState([]);

  const [packageDetails, setPackageDetails] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
    // props.func();
    getTemplates(company.id);
    getInspections(company.id);
    getSites(company.id);
    getPackageDetails();
    setValues({
      ...value,
      company_id: company.id,
    });
  }, [company?.id]);

  function getISOWeekInMonth(date) {
    // Copy date so don't affect original
    var d = new Date(+date);
    if (isNaN(d)) return;
    // Move to previous Monday
    // d.setDate(d.getDate() - d.getDay() + 1);
    // Week number is ceil date/7
    return (
      "week " + Math.ceil(d.getDate() / 7) + " of " + moment(d).format("MMMM")
    );
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  function getTemplates(currentCompany) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_all_templates?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setTemplates(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          // console.log(status);
          if (status) {
            getTemplates(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getInspections(currentCompany) {
    console.log("+++++++++++++++++++++++++++++++++++++Get Inspections Called")
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_all_schedules_organization?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response,"inspections**************************************");
        if (response.status === "Success") {
          await setInspections(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getInspections(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getSites(currentCompany) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let arr = [];
        data.data.map((value, index) => {
          //console.log(value.title);
          value.Areas.map((area, i) => {
            area.Sites.map((sites, j) => {
              // console.log(value.title, area.title, sites.title);
              let obj = {
                title: sites.title,
                id: sites.id,
              };
              if (sites.status !== "deactivated") {
                arr.push(obj);
              }
              //console.log(obj);
              setSites(arr);
            });
            //console.log(this.state.row);
            //console.log(result.title,value.title);
          });
        });
      });
  }

  async function customGroupData(e, arr) {
    // console.log(e, arr);

    let ini_arr = filteredInspection;

    if (arr) {
      ini_arr = arr;
    }

    let arr_data = [];
    let section_data = [];
    let site_arr = [];
    let answers_obj = {};
    await ini_arr.map(async (v) => {
      let score_arr = [];
      let group_value = getISOWeekInMonth(new Date(v.createdAt));

      if (e === "Month") {
        group_value = moment(v.createdAt).format("MMMM yyyy");
      }

      if (e === "Quater") {
        group_value =
          parseInt(new Date(v.createdAt).getMonth() / 3) +
          1 +
          " Quater of " +
          moment(v.createdAt).format("yyyy");
      }

      if (e === "Year") {
        group_value = moment(v.createdAt).format("yyyy");
      }
      let filtered_answers = v.InspectionAnswers?.filter(
        (v) => v.parent_id == null
      );
      await filtered_answers?.map(async (ans, iAns) => {
        answers_obj[ans.check_id] = ans.value;
        // console.log(ans.value, "op current", ans.check_id);

        if (
          ans.value == null ||
          ans.value == "" ||
          ans.value == 0 ||
          ans.value == "[]" ||
          ans.value?.length == 0 ||
          ans.parent_id !== null
        ) {
        } else score_arr.push(ans);
      });
      let obj = {
        title: v.Schedule?.title,
        date: v.createdAt,
        group_value,
        score:
          ((filtered_answers.length -
            (filtered_answers.length - score_arr.length)) /
            filtered_answers.length) *
          100,
      };
      // console.log(obj.score);
      arr_data.push(obj);
      site_arr.push({ ...obj, ...v.Schedule?.Site, type: "current" });

      await v.TemplateInspection?.SectionInspections.sort(
        (a, b) => a.position - b.position
      ).map((temp) => {
        section_data.push({ ...temp, type: "current" });
      });
    });

    let filter_date_group = await _.groupBy(arr_data, (v) => v.group_value);
    let grouped_sections = await _.groupBy(section_data, (v) => v.title);

    let final_arr = [["No of " + e, "No of Inspections"]];

    await Object.keys(filter_date_group).map((v) => {
      final_arr.push([v, filter_date_group[v].length]);
    });

    let avg_score = 0;

    await arr_data.map((v) => {
      avg_score += v.score;
    });

    setPerformanceData({
      chart_data:
        final_arr.length !== 1
          ? final_arr.sort(function(a, b) {
              return b[1] - a[1];
            })
          : [],
      inspection: arr,
      score: (avg_score / arr_data.length).toFixed(),
      answers_obj,
      grouped_sections,
      total_inspections: arr_data.length,
      section_data,
      site_arr,
    });

    // console.log(avg_score, arr_data);
  }

  function handleSideBarChange(event) {
    // let { value, name } = event.target;

    // console.log(name, value);
    setValues({
      ...value,
      [event.target.name]: event.target.value,
    });
    if(event.target.name == "company_id"){
      console.log("event.target.value",event.target.value)
      getInspections(event.target.value);
      getSites(event.target.value);
      getTemplates(event.target.value);
      setValues({
        ...value,
        template_id:"",
        schedule_id:'',
        site_id:'',
      });
    }
  }

  function handleSideBarSubmitProgress() {
    setOpen(false);
    if (!value.template_id) {
      swal(t("Template is required"), "", "warning");
      return;
    }
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id:  value.company_id,
      end_date: value.end,
      from_date: value.from,
      template_id: value.template_id?.id,
      site_id: value.site_id?.id,
      schedule_id: value.schedule_id?.id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    // console.log(query);
    fetch(GlobalApi + "/Inspection/get_all_inspections_progress_new?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setFilteredInspection(response.data);
          customGroupData("Week", response.data);
          setBtnLoader(false);
          setModal("performance",false)
        }
      });
  }

  function handleSideBarSubmitProgressPrevious() {
    setOpen(false);

    if (!value.template_id) {
      swal(t("Template is required"), "", "warning");
      setBtnLoader(false);
      return;
    }
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id:  value.company_id,
      end_date: value.previous_end,
      from_date: value.previous_from,
      template_id: value.template_id?.id,
      site_id: value.site_id?.id,
      schedule_id: value.schedule_id?.id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    // console.log(query);
    fetch(GlobalApi + "/Inspection/get_all_inspections_progress_new?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let arr_data = [];
          let section_data = [];

          let answers_obj = {};
          // setFilteredInspection(response.data);
          // customGroupData("Week", response.data);
          let site_arr = [];
          // console.log()
          await response.data.map(async (v) => {
            let score_arr = [];
            let filtered_answers = v.InspectionAnswers?.filter(
              (v) => v.parent_id == null
            );
            await filtered_answers?.map(async (ans, iAns) => {
              answers_obj[ans.check_id] = ans.value;
              // console.log(ans.value, "op previous", ans.check_id);
              if (
                ans.value == null ||
                ans.value == "" ||
                ans.value == 0 ||
                ans.value == "[]" ||
                ans.value?.length == 0 ||
                ans.parent_id !== null
              ) {
              } else score_arr.push(ans);
            });
            let obj = {
              title: v.Schedule?.title,
              date: v.createdAt,
              // group_value,
              score:
                ((filtered_answers.length -
                  (filtered_answers.length - score_arr.length)) /
                  filtered_answers.length) *
                100,
            };
            // console.log(obj.score);
            arr_data.push(obj);
            site_arr.push({ ...obj, ...v.Schedule?.Site, type: "previous" });

            await v.TemplateInspection?.SectionInspections.sort(
              (a, b) => a.position - b.position
            ).map((temp) => {
              // console.log("+++++++", temp.title)
              section_data.push({ ...temp, type: "previous" });
            });
          });

          let avg_score = 0;
          // console.log(site_arr, "{}{}{}{}}");
          await arr_data.map((v) => {
            avg_score += v.score;
          });
          let grouped_sections = await _.groupBy(section_data, (v) => {
            // console.log(v.title)
            return v.title;
          });
          setPerformanceDataPrevious({
            inspection: response.data,
            score: (avg_score / arr_data.length).toFixed(),
            answers_obj,
            grouped_sections,
            total_inspections: response.data.length,
            section_data,
            site_arr,
          });
          
        }
      });
  }
  if (packageDetails !== null) {
    return (
      <NewDashboard
        value={value}
        handleSideBarSubmitProgress={handleSideBarSubmitProgress}
        handleSideBarChange={handleSideBarChange}
        templates={templates}
        companies={companies}
        inspections={inspections}
        sites={sites}
        handleSideBarSubmitProgressPrevious={
          handleSideBarSubmitProgressPrevious
        }
        packageDetails={packageDetails}
        performanceData_1={performanceData}
        customGroupData={customGroupData}
        performanceDataPrevious={performanceDataPrevious}
        btnLoader={btnLoader}
        setBtnLoader={setBtnLoader}
        openModal={openModalPerformance}
        setModal={setModal}
      />
    );
  } else {
    return <Spinner />;
  }
}
